const RUTA_IMAGEN = 'https://dvarela.com/api/'
const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

const Utiles = {
  generarURL(imagen) {
    if (!imagen) return ''
    if (imagen.startsWith('data:') || imagen.startsWith('http')) return imagen
    return RUTA_IMAGEN + imagen
  },

  obtenerClaves(array) {
    return array.map(el => el[Object.keys(el)[0]])
  },

  obtenerValores(array) {
    return array.map(el => el.numeroVisitas)
  },

  obtenerValoresPagos(array) {
    return array.map(el => parseInt(el.total))
  },

  cambiarDiaSemana(array) {
    for (let i = 0; i < array.length; i++) {
      const pos = array[i].numeroDia
      array[i].dia = DIAS[pos - 1]
    }
    return array
  },

  cambiarNumeroANombreMes(arreglo) {
    for (let i = 0; i < arreglo.length; i++) {
      const pos = arreglo[i].mes
      arreglo[i].mes = MESES[pos - 1]
    }
    return arreglo
  },

  formatearMoneda(valor, moneda = '$') {
    const n = parseFloat(valor) || 0
    return `${moneda}${n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
  },

  formatearFecha(fecha) {
    if (!fecha) return '-'
    return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })
  },

  MESES,
  DIAS,
}

export default Utiles


// WEBPACK FOOTER //
// ./src/Servicios/Utiles.js